import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3bcf317f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 ant-col-xxl-24" }
const _hoisted_4 = {
  class: "ant-row",
  style: {"flex":"1","min-height":"0"}
}
const _hoisted_5 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-24",
  style: {"height":"100%"}
}
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_titulo_padrao, {
              identificadorRecurso: 'VENDAS_BI',
              tituloRecurso: _ctx.state.tituloRecurso,
              exibirAtalhosTela: false,
              exibirHistoricoTela: false,
              empresasSelecionadas: []
            }, null, 8, ["tituloRecurso"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("iframe", {
              src: _ctx.state.biUrl,
              style: {"width":"100%","height":"100%","border":"none"},
              title: "Painel de BI de Vendas"
            }, null, 8, _hoisted_6)
          ])
        ])
      ]),
      _: 1
    })
  ]))
}